<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label [for]="idHtml">{{libelle$ | async }}</label>
    <div class="input-group">
        <div class="input-group-preprend" *ngIf="prefixe">
          <span class="input-group-text">{{prefixe}}</span>
        </div>
       <!--<input [readOnly]="afficherEnLectureSeule" type="text" suffix="" prefix="+" [dropSpecialCharacters]="false" mask="+(000) 00 00 00 00||00 00 00 00 00" [showMaskTyped]="true" [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControlName]="label" class="form-control" [id]="idHtml">-->
       <input [readOnly]="afficherEnLectureSeule" type="text"  [mask]="maskFormat" [class.is-warning]="aErreurCroiseeActive()" [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControlName]="label" class="form-control" [id]="idHtml">
      </div>    
    <bis-affiche-erreurs *ngIf="erreursAffichable()" class="col-12" [erreurs]="rootForm.get(label).errors"></bis-affiche-erreurs>
  </div>
</form>